export default "__VITE_ASSET__qah05OzH__"